import { Uploader, FileInfo, SelectedEventArgs, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { ImportConfigurationAs2FormType } from './configuration-form-as2-form-type';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaStorageTypeHelper } from 'src/app/base/shared/media-storage-type-helper';
import { MimeTypeHelper } from 'src/app/base/shared/mime-type.helper';
import { TranslateModule } from '@ngx-translate/core';

import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-configuration-form-as2',
    templateUrl: './configuration-form-as2.component.html',
    styleUrls: ['./configuration-form-as2.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, UploaderModule, TranslateModule]
})
export class ConfigurationFormAs2Component implements OnInit {
  @ViewChild('defaultupload') public defaultupload: Uploader;

  public get configurationFormAs2(): FormGroup<ImportConfigurationAs2FormType> {
    return this.formsCoordinationService.configurationFormAs2;
  }

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
  ) { }

  ngOnInit() {
    this.configurationFormAs2.controls.doSignMessages.valueChanges.subscribe(() => {
      if (this.configurationFormAs2.controls.doSignMessages.value != true) {
        this.onFileRemove();
      }
      this.formsCoordinationService.setValidatorsForAs2ConfigForm();
    });
  }

  public handleFileInput($event: SelectedEventArgs) {
    const files: FileInfo[] = $event.filesData;
    if (!files || files.length < 1) {
      return;
    }
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      let base64Data = event.target.result as string;
      const startIndex = base64Data.search(';base64,');
      if (startIndex > 0) {
        // replace type by cert
        base64Data = 'data:' + MimeTypeHelper.getMimeType(file.type.toLowerCase()) + base64Data.substring(startIndex);
      } else {
        base64Data = 'data:' + MimeTypeHelper.getMimeType(file.type.toLowerCase()) + ';base64,' + base64Data;
      }
      this.configurationFormAs2.controls.certificateContentBase64.setValue(base64Data);
    };
    reader.readAsDataURL(file.rawFile as File);
    this.configurationFormAs2.controls.certificateMediaName.setValue(file.name);
    const mediaType = MediaStorageTypeHelper.mapFileTypeToMediaType(file.type);
    this.configurationFormAs2.controls.certificateMediaType.setValue(mediaType);
    this.configurationFormAs2.controls.certificateMediaId.setValue(null);
  }

  public onFileRemove() {
    this.defaultupload?.refresh(); // get rid of added input fields
    this.configurationFormAs2.controls.certificateMediaId.setValue(null);
    this.configurationFormAs2.controls.certificateMediaName.setValue(null);
    this.configurationFormAs2.controls.certificateContentBase64.setValue(null);
    this.configurationFormAs2.controls.certificateMediaType.setValue(null);
    this.configurationFormAs2.controls.certificatePassword.setValue(null);
    this.defaultupload?.clearAll();
  }
}
